import { ApiConfig } from "../apiConfig/apiConfig";
import { ApiCallGet, ApiCallPost } from "../apiConfig/apiCall";

const otcRoot = `${ApiConfig.baseUrl}v1/otc/`;

const bearerHeaders = () => {
  let raw = null;
  try {
    raw = localStorage.getItem("token") || sessionStorage.getItem("token");
  } catch {
    raw = null;
  }
  if (!raw) {
    return { "Content-Type": "application/json" };
  }
  const token = String(raw).startsWith("Bearer ") ? raw : `Bearer ${raw}`;
  const headers = { "Content-Type": "application/json", Authorization: token };
  return headers;
};

function withQuery(path, params) {
  if (!params) return `${otcRoot}${path}`;
  const q = new URLSearchParams();
  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value === undefined || value === null || value === "") return;
    q.set(key, String(value));
  });
  const qs = q.toString();
  return qs ? `${otcRoot}${path}?${qs}` : `${otcRoot}${path}`;
}

const OtcService = {
  getAssets: async () => {
    return ApiCallGet(withQuery("assets"), bearerHeaders());
  },

  createRfq: async (payload) => {
    return ApiCallPost(`${otcRoot}rfq`, payload, bearerHeaders());
  },

  getRfq: async (id) => {
    return ApiCallGet(`${otcRoot}rfq/${encodeURIComponent(id)}`, bearerHeaders());
  },

  getCurrent: async () => {
    return ApiCallGet(`${otcRoot}rfq/current`, bearerHeaders());
  },

  cancelRfq: async (id, reason) => {
    const body = {};
    const trimmed = String(reason || "").trim();
    if (trimmed) body.cancel_reason = trimmed;
    return ApiCallPost(
      `${otcRoot}rfq/${encodeURIComponent(id)}/cancel`,
      body,
      bearerHeaders()
    );
  },

  getQuote: async (id) => {
    return ApiCallGet(`${otcRoot}quote/${encodeURIComponent(id)}`, bearerHeaders());
  },

  acceptQuote: async (id, idempotencyKey) => {
    return ApiCallPost(`${otcRoot}quote/${encodeURIComponent(id)}/accept`, {}, {
      ...bearerHeaders(),
      "Idempotency-Key": String(idempotencyKey || "").trim(),
    });
  },

  getTrades: async (params) => {
    return ApiCallGet(withQuery("trades", params), bearerHeaders());
  },

  getTicker: async (params) => {
    return ApiCallGet(withQuery("ticker", params), bearerHeaders());
  },
};

export default OtcService;
